import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card } from '@shopify/polaris'
import styled from 'styled-components'

import Text from 'components/common/Text'

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1em;
  margin-top: 0em;
  flex-shrink: 0;
`
const CardContainer = styled.div`
  max-height: 1200px;
  height: 100%;
  ${props => props.height ? `height: ${props.height};` : ''}
  ${props => props.width ? `width: ${props.width};` : ''}
  ${props => props.top ? `margin-top: ${props.top};` : ''}
`
export default class UICard extends Component {
  render () {
    const { title, actions, description, content, footerLeft, footerRight, height, width, top } = this.props
    return (
      <CardContainer height={height} width={width} top={top}>
        <Card
          title={title}
          actions={actions}
        >
          <Card.Section>
            <Text>{description}</Text>
            {content}
          </Card.Section>
          <Footer>
            {footerLeft || <div />}
            {footerRight || <div />}
          </Footer>
        </Card>
      </CardContainer>
    )
  }
}

UICard.defaultProps = {
  title: '',
  actions: [],
  description: '',
  content: null
}

UICard.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.array,
  description: PropTypes.string,
  content: PropTypes.node,
  footerLeft: PropTypes.node,
  footerRight: PropTypes.node,
  height: PropTypes.string,
  width: PropTypes.string,
  top: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/UICard.js